module.exports = __webpack_public_path__ + "static/media/team-profile2.722e2d1b.png";